export const isArrayBuffer = (v: any): v is ArrayBuffer => v && v instanceof ArrayBuffer && v.byteLength !== undefined;

export const arrayBufferToBase64 = (b: ArrayBuffer) => {
    let binary = '';
    const bytes = new Uint8Array(b);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}